import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
// import classNames from 'classnames';                                  /*strg + p to search files !!!!*/
// import { NamedLink } from '..';
import css from './SectionSteps.css';
// import css from './LandingPage.css';


import value1 from '../../assets/icons/checklist3.svg';
import value2 from '../../assets/icons/support3.svg';
import value3 from '../../assets/icons/worldPin3.svg';



// import line from '../../assets/icons/line.png';

export class SectionSteps extends Component {
  constructor(props) {
    super(props);
    // same same - weasel
    const {} = props;
    this.state = {
      firstToggle: 'first',
    };
  }

  render() {
    return (
      <>
       
        <div className={css.items}>
            <div className={css.item}>
              <img src={value1} alt="" />
              <p className={css.item_Subtitle}>
                <FormattedMessage id="sectionSteps.one" />
              </p>
            </div>

            <div className={css.item}>
              <img src={value3} alt="" />
              <p className={css.item_Subtitle}>
                  <FormattedMessage id="sectionSteps.two" />
              </p>
            </div>
            <div  className={css.item}>
              <img src={value2} alt="" />
              <p className={css.item_Subtitle}>
                  <FormattedMessage id="sectionSteps.three" />
              </p>
            </div>
        </div>
        </>
    );
      
     
  }
}

SectionSteps.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionSteps.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionSteps;
